module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/ecomm/ecomm-04-82fe968427421cef1db1a959411611a1.jpg";